import { Checkbox, ListSubheader, Typography } from '@material-ui/core';
import * as React from 'react';
import Version from 'src/new/versions/Version';
import VersionGroup from 'src/new/versions/VersionGroup';
import SelectedVersions, { SelectAction, SelectedState } from 'src/versions/SelectedVersions';
import './VersionListGroup.css';
import VersionListItem from './VersionListItem';

interface Props {
    group: VersionGroup;
    versions: Version[];
    selectedVersions: SelectedVersions;
    onSelectedVersionsChange: (selectedVersions: SelectedVersions) => void;
}

export default class VersionListGroup extends React.Component<Props> {

    private isShiftKeyDown = false;

    constructor(props: Props) {
        super(props);
        this.handleTickBoxKeyDownUp = this.handleTickBoxKeyDownUp.bind(this);
        this.handleTickBoxChange = this.handleTickBoxChange.bind(this);
        this.handleVersionSelectedChange = this.handleVersionSelectedChange.bind(this);
    }

    public render(): React.ReactNode {
        const selectedState = this.props.selectedVersions.getVersionGroupSelectedState(this.props.versions);
        return (
            <div>
                <ListSubheader className="VersionListGroup_Header">
                    <div className="VersionListGroup_HeaderContent">
                        <Typography
                            className="VersionListGroup_HeaderText"
                            variant="h6">
                            {this.props.group.getName()}
                        </Typography>
                        <Checkbox
                            className="VersionListGroup_HeaderTickBox"
                            checked={selectedState === SelectedState.ALL}
                            indeterminate={selectedState === SelectedState.SOME}
                            onKeyDown={this.handleTickBoxKeyDownUp}
                            onKeyUp={this.handleTickBoxKeyDownUp}
                            onChange={this.handleTickBoxChange} />
                    </div>
                </ListSubheader>
                {this.props.versions.map((version) =>
                    <VersionListItem
                        key={version.getIndex()}
                        version={version}
                        isSelected={this.props.selectedVersions.isVersionSelected(version)}
                        onSelectedChange={this.handleVersionSelectedChange} />
                )}
            </div>
        );
    }

    private handleTickBoxKeyDownUp(event: React.KeyboardEvent<HTMLElement>): void {
        this.isShiftKeyDown = event.shiftKey;
    }

    private handleTickBoxChange(event: React.ChangeEvent<HTMLInputElement>, checked: boolean): void {
        const selectAction = this.getSelectAction(checked, this.isShiftKeyDown);
        this.props.onSelectedVersionsChange(this.props.selectedVersions.setVersions(this.props.versions, selectAction, true));
    }

    private handleVersionSelectedChange(version: Version, isSelected: boolean, isShiftKeyDown: boolean): void {
        const selectAction = this.getSelectAction(isSelected, isShiftKeyDown);
        this.props.onSelectedVersionsChange(this.props.selectedVersions.setVersion(version, selectAction, true));
    }

    private getSelectAction(isSelected: boolean, isShiftKeyDown: boolean): SelectAction {
        if (isShiftKeyDown) {
            return SelectAction.SELECT_ONLY;
        } else {
            return isSelected ? SelectAction.SELECT : SelectAction.DESELECT;
        }
    }
}
